import { useEffect, useState } from 'react'
import { checkPagaleveEligibility as checkEligibilitySvc } from 'services/pagaleveService'

interface Params {
  cpf: string
  amount: number
  phone: string
  email: string
  enabled?: boolean
}

export function usePagaleveEligibility({ cpf, amount, phone, email, enabled = false }: Params) {
  const [isEligible, setIsEligible] = useState(false)
  const [isChecking, setIsChecking] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    async function run() {
      if (!enabled) {
        console.log('[Pagaleve][eligibility] skipped (enabled=false)', {
          hasCpf: Boolean(cpf),
          amount,
          hasPhone: Boolean(phone),
          hasEmail: Boolean(email),
        })
        return
      }
      setIsChecking(true)
      setError(null)
      const eligible = await checkEligibilitySvc({ cpf, amount, phone, email })
      console.log('[Pagaleve][eligibility] eligible:', eligible)
      if (!cancelled) setIsEligible(eligible)
      if (!eligible && !cancelled) {
        setError('Não elegível para Pagaleve')
      }
      if (!cancelled) setIsChecking(false)
    }
    run()
    return () => {
      cancelled = true
    }
  }, [cpf, amount, phone, email, enabled])

  return { isEligible, isChecking, error }
}

